import { useTranslation } from '@chr/online-shared-ui-localizations';
import { Box, Stack } from '@mui/material';
import { MapControlsPanel } from './MapControlsPanel';
import { MapControlSection } from './MapControlSection';
import { SwitchMenuItem } from './SwitchMenuItem';
import { useTrackingMap } from './TrackingMapProvider';

interface MapLayerControlsProps {
  toggleLayers: () => void;
}

export const MapLayerControls = ({
  toggleLayers
}: MapLayerControlsProps) => {
  const translate = useTranslation();
  const {
    isTrafficEnabled,
    isDisruptionsEnabled,
    isWeatherEnabled,
    setIsDisruptionsEnabled,
    setIsWeatherEnabled,
    setIsTrafficEnabled,
  } = useTrackingMap();

  return (
    <Box
      sx={{
        paddingX: 1,
        backgroundColor: 'white',
        position: 'absolute',
        bottom: 40,
        right: 30,
      }}
    >
      <MapControlsPanel onClose={toggleLayers} data-testid="map-content-panel">
        <Stack gap={3}>
          <MapControlSection title={translate('Information')} gap={0}>
            <SwitchMenuItem
              label={translate('Disruptions')}
              checked={isDisruptionsEnabled}
              onChange={(checked) => {
                setIsDisruptionsEnabled(checked)
              }}
            />
            <SwitchMenuItem
              label={translate('Traffic')}
              checked={isTrafficEnabled}
              onChange={(checked) => {
                setIsTrafficEnabled(checked)
              }}
            />
            <SwitchMenuItem
              label={translate('Weather')}
              checked={isWeatherEnabled}
              onChange={(checked) => setIsWeatherEnabled(checked)}
            />
          </MapControlSection>
        </Stack>
      </MapControlsPanel>
    </Box>
  );
};
